import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a `smart` component. It will remember which *Impression components have
 * been rendered to the screen and seen by the user.
 *
 * *
 * Dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { impressionReported as _impressionReported } from '../actions';
export default (function (ImpressionComponent) {
  var ImpressionState = /*#__PURE__*/function (_Component) {
    _inherits(ImpressionState, _Component);

    function ImpressionState() {
      _classCallCheck(this, ImpressionState);

      return _possibleConstructorReturn(this, _getPrototypeOf(ImpressionState).apply(this, arguments));
    }

    _createClass(ImpressionState, [{
      key: "componentWillMount",
      // eslint-disable-next-line react/no-deprecated
      value: function componentWillMount() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (!this.props.impressions && process.env.NODE_ENV === 'development') {
          console.error('`impressions` reducer not found. Make sure to' + 'import the reducer and add to your redux store');
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(ImpressionComponent, this.props);
      }
    }]);

    return ImpressionState;
  }(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  ImpressionState.displayName = 'ImpressionState'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  ImpressionState.propTypes = {
    id: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    impressions: PropTypes.object,
    impressionReported: PropTypes.func.isRequired,
    hasBeenTracked: PropTypes.bool.isRequired
  };
  return connect(function (state, ownProps) {
    return {
      hasBeenTracked: !!state.impressions[ownProps.id],
      impressions: state.impressions
    };
  }, function (dispatch, ownProps) {
    return {
      impressionReported: function impressionReported(eventData) {
        return dispatch(_impressionReported(ownProps.id, eventData));
      }
    };
  })(ImpressionState);
});